import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchPageData = createAsyncThunk("page/fetchPageData", async ({ page_id, lang = "en" }) => {
  const response = await axios.post(
    "https://milkys.bytesway.io/api/data-page",
    {
      page_id,
      lang,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data.data;
});

const pageSlice = createSlice({
  name: "page",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchPageData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPageData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPageData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default pageSlice.reducer;
